import { AppRoutes } from "enums/routes.enum";
import { ReactComponent as LostPhoneIcon } from "assets/icons/account-menu/lost-phone.svg";
import { ReactComponent as FindByNumberIcon } from "assets/icons/account-menu/by-number.svg";
import { ReactComponent as LocateByLinkIcon } from "assets/icons/account-menu/by-link.svg";

export const menuList = [
    {
        title: "Location by number",
        path: AppRoutes.FIND_DEVICE,
        icon: <FindByNumberIcon />,
    },
    {
        title: "Location by link",
        path: AppRoutes.GENERATE_LINK,
        icon: <LocateByLinkIcon />,
    },
    {
        title: "Find lost phone",
        path: AppRoutes.LOST_PHONE,
        icon: <LostPhoneIcon />,
    },
];
